<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back();" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>{{ `${PCM.codigo} - ${PAP.nome}` }}</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="abas">
            <a v-for="a in abas" :key="a.id"
                :class="[{ 'ativo': abaAtiva === a.id }, { 'disabled': (PAP.id === 'criar' && a.id === 2) }]"
                @click="PAP.id !== 'criar' ? abaAtiva = a.id : null">{{ a.label }}</a>
        </div>
        <div class="bloco margem">
            <PcmComponent v-if="abaAtiva === 1" :propPCM="PCM" @getPAP="getPAP" />
            <PlanejamentoComponent v-if="abaAtiva === 2" :propPAP="PAP" @atualizar="getPAP()" />
        </div>
    </div>
</template>

<script>
import { useApiError } from "@/composables/useApiError";
import PlanejamentoComponent from "@/components/PAP/PlanejamentoComponent.vue";
import PcmComponent from "@/components/PCM/pcmComponent.vue";
import servicePAP from "@/services/servicePAP";
import servicePCM from "@/services/servicePCM";

export default {
    components: {
        PcmComponent,
        PlanejamentoComponent,
    },

    props: {
        idPAP: {
            type: [String, Number],
            required: true,
        },
    },

    data() {
        return {
            PAP: {},
            PCM: {},
            abas: [{ id: 1, label: 'Documentação' }, { id: 2, label: 'Planejamento' }],
            abaAtiva: 2
        }
    },

    setup() {
        const { handleError } = useApiError({ message: "Não foi possível carregar o PAP." });
        return { handleApiError: handleError };
    },

    mounted() {
        this.getPAP();
    },

    methods: {
        async getPAP(id) {
            if (this.idPAP === "criar" && !id) {
                this.PCM = { codigo: "Criar", id: "criar", tipo: "PAP", nivel: "Operacional" };
                this.PAP = { id: "criar", nome: "Novo PAP" };
                this.abaAtiva = 1;
                return;
            }
            try {
                const response = await servicePAP.getPAP(id ?? this.idPAP);
                this.PAP = response[0];
                await this.getPCM(this.PAP.pcm_id);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getPCM(id) {
            try {
                this.PCM = await servicePCM.getPCM(id);
            } catch (error) {
                this.handleApiError(error);
            }
        }
    }
}
</script>

<style scoped>
:disabled {
    opacity: 0.8;
    cursor: not-allowed;
}
</style>